'use client';

import { ChatAIIcon } from './chatbot-icons';
import { MessageProps } from './models';

export function Message({ content, sender, timestamp }: MessageProps) {
    const isUser = sender === 'user';

    return (
        <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} gap-3 mb-4 animate-fade-in`}>
            {!isUser && (
                <div
                    className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#05a6f0] shadow-lg"
                    aria-hidden
                >
                    <ChatAIIcon className="h-5 w-5" size={20} />
                </div>
            )}

            <div className={`w-full max-w-xs lg:max-w-md ${isUser ? 'flex justify-end' : ''}`}>
                <div
                    className={`px-4 py-3 rounded-xl ${
                        isUser
                            ? 'bg-[#05a6f0] text-white rounded-br-none shadow-md'
                            : 'bg-white text-black rounded-bl-none shadow-sm border border-gray-100'
                    }`}
                >
                    <div className={`text-sm leading-relaxed font-medium ${isUser ? 'text-white' : 'text-gray-600'}`}>
                        {content}
                    </div>
                    {timestamp && (
                        <div className={`text-xs mt-1.5 ${isUser ? 'text-blue-100' : 'text-black'}`}>
                            {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
